import { supabase } from "@/integrations/supabase/client";

/**
 * Resolves the apartment ID for a user.
 * Checks users.apartment_id first, then falls back to user_apartments table
 * so cotenants (secondary tenants) see the same data as primary tenants.
 */
export async function getUserApartmentId(userId: string): Promise<string | null> {
  // 1. Check direct assignment on users table
  const { data: userData } = await supabase
    .from("users")
    .select("apartment_id")
    .eq("id", userId)
    .maybeSingle();

  if (userData?.apartment_id) {
    return userData.apartment_id;
  }

  // 2. Fallback: check user_apartments table (cotenant)
  const { data: ua } = await supabase
    .from("user_apartments")
    .select("apartment_id")
    .eq("user_id", userId)
    .limit(1)
    .maybeSingle();

  if (ua?.apartment_id) {
    return ua.apartment_id;
  }

  // 3. Fallback: check unit_owners table (owner role)
  const { data: uo } = await supabase
    .from("unit_owners")
    .select("apartment_id")
    .eq("user_id", userId)
    .limit(1)
    .maybeSingle();

  return uo?.apartment_id ?? null;
}
